// import React, { useEffect, useState } from "react";
// import axios from "axios";

// function Setting() {
//   const [websiteActive, setWebsiteActive] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState({ text: "", type: "" });

//   // ✅ Backend se current status
//   useEffect(() => {
//     axios
//       .get("https://grocerrybackend.vercel.app/api/settings")
//       .then((res) => {
//         setWebsiteActive(res.data.websiteActive);
//         setLoading(false);
//       })
//       .catch(() => {
//         setMessage({ 
//           text: "Backend not connected!", 
//           type: "error" 
//         });
//         setLoading(false);
//       });
//   }, []);

//   // ✅ Toggle API Call
//   const toggleWebsite = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.put(
//         "https://grocerrybackend.vercel.app/api/settings/toggle"
//       );
//       setWebsiteActive(res.data.websiteActive);
//       setMessage({ 
//         text: res.data.websiteActive 
//           ? "✅ Website is now ONLINE" 
//           : "⚠️ Website is now OFFLINE", 
//         type: "success" 
//       });
//     } catch (err) {
//       setMessage({ 
//         text: "Toggle Failed", 
//         type: "error" 
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="p-4">
//       <div className="mb-6">
//         <h1 className="text-xl font-bold text-gray-800">Settings</h1>
//       </div>

//       <div className="bg-white rounded-lg shadow-sm border border-gray-200">
//         <div className="p-6">
//           {message.text && (
//             <div className={`mb-4 p-3 rounded-lg ${
//               message.type === 'success' 
//                 ? 'bg-green-50 text-green-800 border border-green-200' 
//                 : 'bg-red-50 text-red-800 border border-red-200'
//             }`}>
//               {message.text}
//             </div>
//           )}

//           <div className="space-y-6">
//             <div>
//               <h3 className="font-semibold text-gray-800 mb-4">Website ONLINE Control</h3>
              
//               <div className="flex items-center justify-between bg-gray-50 p-4 rounded-lg border border-gray-200">
//                 <div>
//                   <p className="font-medium text-gray-700">Website Status</p>
//                   <p className={`text-sm mt-1 ${
//                     websiteActive ? "text-green-600" : "text-red-600"
//                   }`}>
//                     {websiteActive ? "● ONLINE - Website is accessible to users" : "● OFFLINE - Website is under maintenance"}
//                   </p>
//                 </div>
                
//                 <div className="flex items-center space-x-4">
//                   <span className={`px-3 py-1 rounded-full text-sm font-medium ${
//                     websiteActive 
//                       ? "bg-green-100 text-green-800" 
//                       : "bg-red-100 text-red-800"
//                   }`}>
//                     {websiteActive ? "ON" : "OFF"}
//                   </span>
                  
//                   <button
//                     onClick={toggleWebsite}
//                     disabled={loading}
//                     className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${
//                       websiteActive 
//                         ? "bg-red-600 hover:bg-red-700 text-white" 
//                         : "bg-blue-600 hover:bg-blue-700 text-white"
//                     } disabled:opacity-50 disabled:cursor-not-allowed`}
//                   >
//                     {websiteActive ? "Turn OFF" : "Turn ON"}
//                   </button>
//                 </div>
//               </div>

//               <p className="text-xs text-gray-500 mt-3">
//                 {websiteActive 
//                   ? "When website is ON, users can access all features and place orders." 
//                   : "When website is OFF, users will see a maintenance message and cannot place orders."}
//               </p>
//             </div>

//             <div className="border-t border-gray-200 pt-6">
//               <h4 className="font-medium text-gray-700 mb-2">How it works:</h4>
//               <ul className="text-sm text-gray-600 space-y-1">
//                 <li className="flex items-start">
//                   <span className="text-blue-500 mr-2">•</span>
//                   <span>Toggle switch to control website availability</span>
//                 </li>
//                 <li className="flex items-start">
//                   <span className="text-blue-500 mr-2">•</span>
//                   <span>OFF mode shows maintenance page to users</span>
//                 </li>
//                 <li className="flex items-start">
//                   <span className="text-blue-500 mr-2">•</span>
//                   <span>Admin panel remains accessible in both modes</span>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Setting;









import React, { useEffect, useState } from "react";
import axios from "axios";

function Setting() {
  const [websiteActive, setWebsiteActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [isToggling, setIsToggling] = useState(false);

  // ✅ Backend se current status
  useEffect(() => {
    axios
      .get("https://grocerrybackend.vercel.app/api/settings")
      .then((res) => {
        setWebsiteActive(res.data.websiteActive);
        setLoading(false);
      })
      .catch(() => {
        setMessage({ 
          text: "Backend not connected!", 
          type: "error" 
        });
        setLoading(false);
      });
  }, []);

  // ✅ Toggle API Call
  const toggleWebsite = async () => {
    if (isToggling) return; // Prevent multiple clicks
    
    try {
      setIsToggling(true);
      // Immediately update UI for instant feedback
      const newStatus = !websiteActive;
      setWebsiteActive(newStatus);
      
      // Make API call
      const res = await axios.put(
        "https://grocerrybackend.vercel.app/api/settings/toggle"
      );
      
      // Ensure UI matches backend response
      setWebsiteActive(res.data.websiteActive);
      
      setMessage({ 
        text: res.data.websiteActive 
          ? "✅ Website is now ONLINE" 
          : "⚠️ Website is now OFFLINE", 
        type: "success" 
      });
    } catch (err) {
      // Revert UI on error
      setWebsiteActive(!websiteActive);
      setMessage({ 
        text: "Toggle Failed", 
        type: "error" 
      });
    } finally {
      setIsToggling(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

return (
  <div className="p-4">
    <div className="mb-6">
      <h1 className="text-xl font-bold text-gray-800">Settings</h1>
    </div>

    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="p-6">
        {message.text && (
          <div className={`mb-4 p-3 rounded-lg ${
            message.type === 'success' 
              ? 'bg-green-50 text-green-800 border border-green-200' 
              : 'bg-red-50 text-red-800 border border-red-200'
          }`}>
            {message.text}
          </div>
        )}

        <div className="space-y-6">
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Website ONLINE Control</h3>
            
            <div className="flex items-center justify-between bg-gray-50 p-4 rounded-lg border border-gray-200">
              <div>
                <p className="font-medium text-gray-700">Website Status</p>
                <p className={`text-sm mt-1 ${
                  websiteActive ? "text-green-600" : "text-red-600"
                }`}>
                  {websiteActive ? "● ONLINE - Website is accessible to users" : "● OFFLINE - Website is under maintenance"}
                </p>
              </div>
              
              <div className="flex items-center space-x-4">
                {/* Enhanced Toggle Switch */}
                <div className="flex items-center space-x-3">
                  <div className="flex flex-col items-center">
                    <button
                      onClick={toggleWebsite}
                      disabled={isToggling}
                      className={`
                        relative inline-flex h-8 w-16 items-center rounded-full 
                        transition-all duration-500 ease-in-out
                        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                        ${isToggling ? 'opacity-90 cursor-wait' : 'cursor-pointer hover:opacity-90'}
                        ${websiteActive 
                          ? 'bg-gradient-to-r from-green-400 to-green-600' 
                          : 'bg-gradient-to-r from-red-400 to-red-600'
                        }
                      `}
                    >
                      {/* Toggle Knob with inner animation */}
                      <span className={`
                        absolute inline-flex h-6 w-6 transform rounded-full bg-white 
                        shadow-lg transition-all duration-500 ease-in-out
                        flex items-center justify-center
                        ${websiteActive ? 'translate-x-9' : 'translate-x-1'}
                      `}>
                        {/* Inner dot */}
                        <span className={`
                          h-3 w-3 rounded-full transition-all duration-300
                          ${websiteActive ? 'bg-green-500' : 'bg-red-500'}
                        `} />
                      </span>
                    </button>
                    
                    {/* Status Labels */}
                    <div className="flex justify-between w-full mt-2 px-1">
                      <span className={`text-xs font-medium ${
                        !websiteActive ? 'text-red-600 font-bold' : 'text-gray-500'
                      }`}>
                        OFF
                      </span>
                      <span className={`text-xs font-medium ${
                        websiteActive ? 'text-green-600 font-bold' : 'text-gray-500'
                      }`}>
                        ON
                      </span>
                    </div>
                  </div>
                  
                  {/* Status Badge */}
                  <div className={`px-3 py-1.5 rounded-lg text-sm font-medium border ${
                    websiteActive 
                      ? "bg-green-50 text-green-700 border-green-200" 
                      : "bg-red-50 text-red-700 border-red-200"
                  }`}>
                    {websiteActive ? "ONLINE" : "OFFLINE"}
                  </div>
                </div>
              </div>
            </div>

            <p className="text-xs text-gray-500 mt-3">
              {websiteActive 
                ? "When website is ON, users can access all features and place orders." 
                : "When website is OFF, users will see a maintenance message and cannot place orders."}
            </p>
          </div>

          <div className="border-t border-gray-200 pt-6">
            <h4 className="font-medium text-gray-700 mb-2">How it works:</h4>
            <ul className="text-sm text-gray-600 space-y-1">
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>Toggle switch to control website availability</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>OFF mode shows maintenance page to users</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>Admin panel remains accessible in both modes</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
);
}

export default Setting;